/* unplugin-vue-components disabled */import { render } from "./builddetail.vue?vue&type=template&id=61c57bd7&scoped=true"
import script from "./builddetail.vue?vue&type=script&lang=js"
export * from "./builddetail.vue?vue&type=script&lang=js"

import "./builddetail.vue?vue&type=style&index=0&id=61c57bd7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c57bd7"]])

export default __exports__